<template>
  <form class="step" @submit.prevent>

    <!-- Имя -->
    <bimInput
      autocomplete="off"
      v-model="form.firstName"
      :placeholder="$bimTranslate('signUp.name', activeLang)"
      class="step__item step__item--padding"
      :formModel="_self"
      formKey="form.firstName"
    />

    <!-- Фамилия -->
    <bimInput
      autocomplete="off"
      v-model="form.lastName"
      :placeholder="$bimTranslate('signUp.lastName', activeLang)"
      class="step__item step__item--padding"
      :formModel="_self"
      formKey="form.lastName"
    />

    <!-- Почта -->
    <bimInput
      autocomplete="off"
      v-model="form.email"
      :placeholder="$bimTranslate('form.email', activeLang)"
      class="step__item step__item--padding"
      :formModel="_self"
      formKey="form.email"
    />

    <!-- Роль -->
    <bimSelect
      :value="roleType || form.context.role || ''"
      @input="val => form.context.role = val"
      :options="roles"
      class="step__item step__item--padding step__item--white"
      width="100%"
      :formModel="_self"
      :disabled="!!roleType"
      formKey="form.context.role"
      :placeholder="$bimTranslate('signUp.notSelected', activeLang)"
    />

    <bimCheckbox
      class="step__item"
      style="margin-top: 5px"
      v-model="form.context.promoAgree"
      id="promoAgree"
    >
      <span>
        Даю согласие на получение рекламной рассылки
      </span>
    </bimCheckbox>
    <bimCheckbox
      class="step__item"
      v-model="form.context.agree"
      id="agree"
    >
      <span>
        Регистрируясь, я даю
        <a
          class="link-dashed step__item-link"
          href="https://bimlib.pro/agreement/"
          target="_blank"
        >
          согласие
        </a>
        на обработку моих персональных данных
      </span>
    </bimCheckbox>

    <bimButton
      class="step__item mt-10"
      :label="$bimTranslate('signUp.buttons.continue', activeLang)"
      @click.prevent="sendForm"
      :disabled="!form.context.agree"
    />
  </form>
</template>

<script>
import bimInput from '@/components/form/bimInput/bimInput'
import bimButton from '@/components/form/bimButton/bimButton'
import bimSelect from '@/components/form/bimSelect/bimSelect'
import bimCheckbox from '@/components/form/bimCheckbox/bimCheckbox'

import StepMixin from './step.mixin'

export default {
  name: 'RegistrationStepOne',
  components: {
    bimInput,
    bimButton,
    bimSelect,
    bimCheckbox
  },
  props: {
    roleType: [String, Boolean]
  },
  mixins: [StepMixin],
  computed: {
    formValidation () {
      return {
        'form.firstName': ['required', 'maxLength=20', 'minLength=2'],
        'form.lastName': ['required', 'maxLength=20', 'minLength=2'],
        'form.email': ['required', 'email'],
        'form.context.role': ['required']
      }
    },
    roles () {
      return Object
        .entries(this.$bimTranslate('signUp.roles', this.activeLang))
        .map(([value, label]) => ({ value, label }))
    }
  }
}
</script>

<style lang="scss" scoped>
.step {

  .step__item {
    width: 100%;
  }

  .step__item-link {
    text-decoration: none;
    border-bottom: 2px dashed #00afa1;
    color: inherit;
  }

  .step__item--padding {
    padding-bottom: 16px;
  }

  .step__item--white {
    background: white;
  }
}
</style>
